var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 49.1211C38.2678 49.1211 49.0234 38.3654 49.0234 25.0977C49.0234 11.8299 38.2678 1.07422 25 1.07422C11.7322 1.07422 0.976562 11.8299 0.976562 25.0977C0.976562 38.3654 11.7322 49.1211 25 49.1211ZM22.5596 36.4163C22.5225 35.0626 23.5059 33.9688 25.1011 33.9688C26.5107 33.9688 27.4937 35.0626 27.4937 36.4163C27.4937 37.8256 26.4549 38.9009 25.0079 38.9009C23.5059 38.9007 22.5596 37.8069 22.5596 36.4163ZM26.9971 29.9257V11.3281H23.0274V29.796L26.9971 29.9257Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWithWhiteCircle);
export default __webpack_public_path__ + "static/media/error_with_white_circle.866ed9e7994e0a4ef08556bf2b05f183.svg";
export { ForwardRef as ReactComponent };